import { render, staticRenderFns } from "./DetailAndOptionsMobile.vue?vue&type=template&id=e810a3d2"
import script from "./DetailAndOptionsMobile.vue?vue&type=script&lang=js"
export * from "./DetailAndOptionsMobile.vue?vue&type=script&lang=js"
import style0 from "./DetailAndOptionsMobile.vue?vue&type=style&index=0&id=e810a3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports